
import React from 'react';


const CV = () => {
  return (
    <>

  <div style={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, maxWidth: '700px', margin: '0 auto' }}>
    <h1>John Speirs</h1>
    <h2>Picture Framer and Hanger</h2>
    <p>23 Anniesland Crescent, G140YQ | 07989226593 | <a href="mailto:john@framingnorah.com">john@framingnorah.com</a> | <a href="https://framingnorah.com" target="_blank" rel="noopener noreferrer">framingnorah.com</a></p>
    
    <section>
      <h2>Professional Summary</h2>
      <p>
        With over thirty years of hands-on experience, I am a highly skilled picture framer, known for meticulous, careful handling of each piece,and strong communication skills to meet client needs. As the owner of Framing Norah, a picture-hanging service, I take a proactive approach to online engagement, brand management, and customer service. I bring a unique blend of craftsmanship, client-focused service, and digital proficiency, making me a valuable addition to any framing team.
      </p>
    </section>
    
    <section>
      <h2>Framing and Business Skills</h2>
      <h3>Picture Framing Expertise</h3>
      <p>
        Skilled in Morso, mount, and glass cutting, as well as underpinning. Experienced with canvas, tapestry, and cross-stitch stretching. Knowledgeable in using conservation glass, board, and archival tapes to ensure quality preservation. Highly detail-oriented, precise, and clean.
      </p>
      <h3>Specialty Items Framed</h3>
      <p>
        Experienced with unique items including <a href="https://framingnorah.com/gallery" target="_blank" rel="noopener noreferrer">medals, maps and sports strips</a>. Also skilled in framing unusual objects like toddlers' shoes, an electric guitar, and a taxidermied bat.
      </p>
      <h3>Customer Relations</h3>
      <p>
        Friendly communicator who provides tailored advice and creates a welcoming environment for clients.
      </p>
      <h3>Digital Proficiency</h3>
      <p>
        Proficient in managing online presence, creating digital content, and engaging on social media. Experienced in website building and brand management. Creative in music and video production.
      </p>
    </section>

    <section>
      <h2>Professional Experience</h2>
      <h3>Largs Hardware Gallery 8 — Bespoke Picture Framer</h3>
      <p>2003 - 2022</p>
      
      <h3>Framing Norah Picture Hanger — Picture Hanging Professional</h3>
      <p>October 2024 - Present</p>
      <p>
        Provides art hanging services utilizing framing, building, and digital skills to help domestic and business clients safely display artwork and mirrors.
        Established <a href="https://framingnorah.com" target="_blank" rel="noopener noreferrer">framingnorah.com</a> to showcase the brand, engage with customers, and share educational content on framing and hanging. Currently focused on SEO refinement to rank on page 1 of Google.
      </p>
    </section>

    <section>
      <h2>Additional Experience</h2>
      <h3>Freelance Musician — Professional Bass Player</h3>
      <p>2003 - Present</p>
      <p>
        Experienced in live and studio performance, composition, and collaboration. Band manager overseeing client negotiations, contracts, accounts, logistics, and relationship management. Over ten years as a YouTube content creator in music and video.
      </p>

      <h3>Software Developer</h3>
      <p>SQA level 8 in Professional Software Development (Codeclan 2022)</p>
    </section>

    <section>
      <h2>Referees</h2>
      <p>Available upon request.</p>
    </section>
  </div>
);

export default CV;

    </>
  );
};

export default CV;